// extracted by mini-css-extract-plugin
module.exports = {"order":"Order_order__RDg-A","order__id":"Order_order__id__2P8DD","order__total":"Order_order__total__2mNlu","order__h2":"Order_order__h2__obvhC","date":"Order_date__14NY8"};